<div class="nav-header">
  <!-- Mobile Hamburger Menu -->
  <div class="mobile-menu-toggle mobile-only" (click)="toggleMobileMenu()">
    <ui-svg-icon svgIcon="hamburger" size="large"></ui-svg-icon>
  </div>

  <div class="logo">
    <a routerLink="catalogs">
      <img class="logo" src="{{ BASE_URL }}/web/binary/company_logo" alt="company's logo" />
    </a>
  </div>
  <!-- Desktop Navigation -->
  <div class="nav-items desktop-only">
    <a routerLink="catalogs" routerLinkActive="active">{{ 'navigation.catalogs' | translate }}</a>
    <a routerLink="orders" routerLinkActive="active">{{ 'navigation.orders' | translate }}</a>
  </div>

  <div class="user-container">
    <div class="user-cart" [class.active]="activeRoute === '/cart'" (click)="goToCart()">
      <ui-svg-icon svgIcon="cart"></ui-svg-icon>
      <div class="cart-info">
        <span class="cart-title">
          {{ 'navigation.cart' | translate }}
          <span class="cart-count">
            {{ cartTotalItems }}
          </span>
        </span>
        <span class="cart-price">
          <span class="info-value" *ngFor="let cart of cartsTotalPricePerCurrency">
            {{ cart.total | amountCurrency: cart.currency?.symbol: cart.currency?.position }}
          </span>
        </span>
      </div>
      <!-- <ui-svg-icon svgIcon="chevron-down"></ui-svg-icon> -->
    </div>
    <div class="user-menu desktop-only" [matMenuTriggerFor]="menu">
      <ui-svg-icon svgIcon="user-cc"></ui-svg-icon>
    </div>
    <mat-menu #menu="matMenu" xPosition="before">
      <div class="user-info" *ngIf="currentUser" (click)="openProfileDialog()">
        <div class="user-image">
          <ui-svg-icon svgIcon="user-cc"></ui-svg-icon>
        </div>
        <div class="user-info-text">
          <span
            [title]="currentUser.contact.contact_fname + ' ' + currentUser.contact.contact_lname"
          >
            {{
              currentUser.contact.contact_fname + ' ' + currentUser.contact.contact_lname
                | displayText: 15
            }}
          </span>
          <span class="company" [title]="currentUser.company.name">
            {{ currentUser.company.name | displayText: 15 }}
          </span>
        </div>
      </div>
      <hr class="separtor" />
      <button mat-menu-item class="logout-btn" (click)="logout()">
        <div style="display: flex; align-items: center; gap: 8px">
          <ui-svg-icon svgIcon="exit" size="medium"></ui-svg-icon>
          {{ 'authentication.logout' | translate }}
        </div>
      </button>
    </mat-menu>
  </div>
</div>

<div class="profile-dialog-overlay" *ngIf="showProfileDialog">
  <!-- <div class="profile-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <div class="header-content">
        <mat-icon class="profile-icon">person</mat-icon>
        <h2>{{ 'profile.title' | translate }}</h2>
      </div>
      <button class="close-button" (click)="closeDialog()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-content">
      <div class="form-section"> <label class="form-label">Name</label> <span class="readonly-input">{{ userProfile.name }}</span> </div>

      <div class="form-section">
        <label class="form-label">{{ 'profile.email' | translate }}</label>
        <span class="readonly-input email">{{ userProfile.email }}</span>
      </div>

      <div class="form-section">
        <label class="form-label">{{ 'profile.profile_picture' | translate }}</label>
        <div class="file-upload-area">
          <input type="file" id="profileImage" accept="image/*" (change)="onFileSelected($event)" hidden />
          <label for="profileImage" class="file-upload-button">
            <ui-svg-icon svgIcon="upload" size="medium" class="upload-icon"></ui-svg-icon>
            <span>{{ 'profile.browse_files' | translate }}</span>
          </label>
        </div>
      </div>


      <div class="form-section">
        <label class="form-label">{{ 'profile.language' | translate }}</label>
        <div class="language-options">
          <div class="row">
            <label class="language-option">
              <input type="radio" value="it" [(ngModel)]="userProfile.language" />
              <img src="/assets/icones/italy.svg" alt="Italian" class="flag-icon" />
              <span>{{ 'language.italian' | translate }}</span>
            </label>
            <label class="language-option">
              <input type="radio" value="fr" [(ngModel)]="userProfile.language" />
              <img src="/assets/icones/france.svg" alt="French" class="flag-icon" />
              <span>{{ 'language.french' | translate }}</span>
            </label>


          </div>
          <div class="row">
            <label class="language-option">
              <input type="radio" value="en" [(ngModel)]="userProfile.language" />
              <img src="/assets/icones/uk.svg" alt="English" class="flag-icon" />
              <span>{{ 'language.english' | translate }}</span>
            </label>
          </div>


        </div>
      </div>

    </div>
    <hr class="separtor" />
    <div class="dialog-actions">
      <button class="cancel-button" (click)="closeDialog()">
        {{ 'profile.cancel' | translate }}
      </button>
      <button class="update-button" (click)="updateProfile()">
        {{ 'profile.update' | translate }}
      </button>
    </div>
  </div> -->

  <app-shared-dialog
    [title]="'profile.title' | translate"
    [options]="{
      titleIcon: 'user-cc',
      confirmText: 'profile.update' | translate,
      cancelText: 'profile.cancel' | translate,
      cancelButtonStyle: 'danger'
    }"
    (cancel)="closeDialog()"
    (confirm)="updateProfile()"
  >
    <div class="dialog-content">
      <!-- Example: Name Section -->
      <div class="form-section">
        <label class="form-label">Name</label>
        <span class="readonly-input">{{ userProfile.name }}</span>
      </div>

      <!-- Example: Email Section -->
      <div class="form-section">
        <label class="form-label">{{ 'profile.email' | translate }}</label>
        <span class="readonly-input email">{{ userProfile.email }}</span>
      </div>

      <!-- Example: File Upload Section -->
      <div class="form-section">
        <label class="form-label">{{ 'profile.profile_picture' | translate }}</label>
        <div class="file-upload-area">
          <ng-container *ngIf="!imagePreview; else previewBlock">
            <input
              type="file"
              id="profileImage"
              accept="image/*"
              (change)="onFileSelected($event)"
              hidden
            />
            <label for="profileImage" class="file-upload-button">
              <ui-svg-icon svgIcon="upload" class="upload-icon" size="large"></ui-svg-icon>
              <span>{{ 'profile.browse_files' | translate }}</span>
            </label>
          </ng-container>
          <ng-template #previewBlock>
            <span class="profile-preview">
              <img [src]="imagePreview" alt="Preview profile" />
              <ui-button
                type="transparent"
                icon="trash"
                iconSize="large"
                (click)="removeProfileImage()"
              ></ui-button>
            </span>
          </ng-template>
        </div>
      </div>

      <!-- Example: Language Section -->
      <div class="form-section">
        <label class="form-label">{{ 'profile.language' | translate }}</label>
        <div class="language-options">
          <div class="row">
            <label class="language-option">
              <input type="radio" value="it" [(ngModel)]="userProfile.language" />
              <img src="/assets/icones/italy.svg" alt="Italian" class="flag-icon" />
              <span>{{ 'language.italian' | translate }}</span>
            </label>
            <label class="language-option">
              <input type="radio" value="fr" [(ngModel)]="userProfile.language" />
              <img src="/assets/icones/france.svg" alt="French" class="flag-icon" />
              <span>{{ 'language.french' | translate }}</span>
            </label>
          </div>
          <div class="row">
            <label class="language-option">
              <input type="radio" value="en" [(ngModel)]="userProfile.language" />
              <img src="/assets/icones/uk.svg" alt="English" class="flag-icon" />
              <span>{{ 'language.english' | translate }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </app-shared-dialog>
</div>

<!-- Mobile Navigation Overlay -->
<div
  class="mobile-nav-overlay"
  [class.active]="isMobileMenuOpen"
  (click)="closeMobileMenu()"
  role="dialog"
  [attr.aria-modal]="isMobileMenuOpen"
  [attr.aria-hidden]="!isMobileMenuOpen"
>
  <div class="mobile-nav-content" (click)="$event.stopPropagation()">
    <div class="mobile-nav-header">
      <div class="mobile-logo">
        <img class="logo" src="{{ BASE_URL }}/web/binary/company_logo" alt="company's logo" />
      </div>
      <ui-button
        type="transparent"
        class="close-btn"
        icon="close-cc"
        (click)="closeMobileMenu()"
      ></ui-button>
    </div>
    <nav role="navigation">
      <a
        routerLink="catalogs"
        routerLinkActive="active"
        (click)="closeMobileMenu()"
        class="mobile-nav-item"
        tabindex="0"
      >
        <ui-svg-icon svgIcon="bloc-note" size="large"></ui-svg-icon>
        <span>{{ 'navigation.catalogs' | translate }}</span>
      </a>
      <a
        routerLink="orders"
        routerLinkActive="active"
        (click)="closeMobileMenu()"
        class="mobile-nav-item"
        tabindex="0"
      >
        <ui-svg-icon svgIcon="box" size="large"></ui-svg-icon>
        <span>{{ 'navigation.orders' | translate }}</span>
      </a>
      <a
        routerLink="cart"
        routerLinkActive="active"
        (click)="closeMobileMenu()"
        class="mobile-nav-item"
        tabindex="0"
      >
        <ui-svg-icon svgIcon="cart" size="large"></ui-svg-icon>
        <span>{{ 'navigation.cart' | translate }}</span>
        <span class="cart-count" *ngIf="cartTotalItems > 0">{{ cartTotalItems }}</span>
      </a>
    </nav>

    <div class="bottom-section">
      <div class="auth-user">
        <div class="user-info" *ngIf="currentUser">
          <div class="user-image">
            <img src="assets/images/avatar.svg" alt="user avatar" />
          </div>
          <!-- <div [title]="currentUser.contact.contact_fname + ' ' + currentUser.contact.contact_lname">{{ (currentUser.contact.contact_fname + ' ' + currentUser.contact.contact_lname) | displayText : 20 }}</div> -->
          <div class="user-info-text">
            <span [title]="currentUser.contact.contact_fname">
              {{
                currentUser.contact.contact_fname + ' ' + currentUser.contact.contact_lname
                  | displayText: 15
              }}
            </span>
            <span class="company" [title]="currentUser.company.name">
              {{ currentUser.company.name | displayText: 15 }}
            </span>
          </div>
        </div>
        <ui-button type="transparent" icon="exit" (click)="logout()"></ui-button>
      </div>
      <hr class="separtor" />
      <div class="powered-by">
        <span>
          {{ 'navigation.powered_by' | translate }}
          <img class="logo" src="assets/images/Logo-Volta.svg" alt="volta logo" />
        </span>
      </div>
    </div>
  </div>
</div>
